export default __webpack_public_path__ + "static/media/logo-v1.dfa8bf61.svg";